import { GATrackingEvent, GATrackingEventPayload } from '~shared/modules/ga-tracking/models';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';

export class GaTrackingBannerClickExperimentEvent implements GATrackingEvent {

  constructor(private event: string) { }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.BannerClickExperiment;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.event
    };
  }
}
